





































import Vue from "vue";
import iwBackOfficeActionReason from "@/myImmoweb/modal/BackOfficeActionReason.vue";
import iwButtonLoading from "@/shared/components/ButtonLoading.vue";
import iwPackDuration from "@/myImmoweb/modal/PackDuration.vue";
import iwPackSelector from "@/myImmoweb/modal/PackSelector.vue";

import { mapActions, mapState } from "vuex";

import { Pricing } from "@/shared/interfaces/pricing/pricing.interface";
import { BackOfficeAction } from "@/shared/interfaces/BackOfficeAction.interface";

import { activateClassified } from "@/shared/scripts/BackOfficeApi";
import { getPricing } from "@/shared/scripts/PricingApi";
import { i18n } from "@/shared/scripts/helpers/translation/i18n";

export default Vue.extend({

    components: {
        iwBackOfficeActionReason: iwBackOfficeActionReason,
        iwButtonLoading: iwButtonLoading,
        iwPackDuration: iwPackDuration,
        iwPackSelector: iwPackSelector,
    },

    data: function() {
        return {
            isLoading: false,
            payload: {} as BackOfficeAction,
            durationPacks: [] as Array<Pricing>,
        };
    },

    computed: mapState("MyClassifiedsModule", ["classifiedToActivate"]),

    created: async function() {
        // try/catch rather than .catch(): getPricing() reads nested classified
        // fields and throws synchronously when they are absent, so a handler
        // attached to its return value never runs. (IO-138)
        try {
            this.durationPacks = await getPricing({ classified: this.classifiedToActivate });
        } catch (error) {
            this.dialog.alert(i18n.t("server_not_responding_error").toString());
            console.error(error);
            this.durationPacks = [];
        }

        // Without this the failure path above fell straight into
        // durationPacks[0].id and threw a second, uncaught error.
        if (!this.durationPacks.length) {
            return;
        }

        this.selectPack("BASIC");
        this.selectTariff(this.durationPacks[0].id);
    },

    methods: {
        ...mapActions({
            closeMasqueradeModal: "ModalModule/closeMasqueradeModal"
        }),

        selectPack: function(packName: string) {
            this.payload.visualizationOption = packName;
        },

        selectTariff: function(tariff: string) {
            this.payload.tariffId = tariff;
        },

        updateInfo: function(info: string) {
            this.payload.info = info;
        },

        activateClassifiedCall: function() {
            this.isLoading = true;
            activateClassified(this.payload).then(res => {
                this.isLoading = false;
                if (res.status === "ACTIVE") {
                    this.$emit("success");
                }
            }).catch(error => {
                this.dialog.alert(i18n.t("server_not_responding_error").toString());
                console.error(error);
                this.isLoading = false;
            });
        },
    }
});
